import React, { useState } from 'react';
import AvailabilityDialog from 'common/components/AvailabilityDialog';
import PricePanel from './PricePanel';
import { QuantityState } from '../common/constants';
import { getProductData } from '../common/productData';

type Props = {
    data: any;
};

const Availability: React.FC<Props> = ({ data }) => {
    const [quantity, setQuantity] = useState<QuantityState>(null);
    const { availability, code, images, minQuantity, name, price, slug, type, taxAmount, } = getProductData(data);

    if (availability) {
        return (
            <PricePanel
                code={code}
                images={images}
                minQuantity={minQuantity}
                name={name}
                price={price}
                setQuantity={setQuantity}
                slug={slug}
                type={type}
                quantity={quantity}
                taxAmount={taxAmount}
            />
        );
    }

    return <AvailabilityDialog code={code} />;
};

export default Availability;
